<!-- sqm 纠偏单 列表 
  components: { hDialog },-->
<template>
  <h-list-page class="RectifyReportList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('6c545c505fa3a4f3ffca3ddc4ae9b051')">
          <h-input clearable v-model="searchData.rectifyId" @change="changeNull(searchData.rectifyId, 'rectifyId')"></h-input>
        </h-search>
        <h-search :title="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')">
          <h-select clearable v-model="searchData.rectifyStatusId" :placeholder="h_i18n('cb08af880c276d42e7773bcd88331d25')" filterable
            @change="changeNull(searchData.rectifyStatusId, 'rectifyStatusId')">
            <h-option value="1221" :label="h_i18n('4a35e03b857bf3cde759bb1390f1bbac')"></h-option>
            <h-option value="1222" :label="h_i18n('e17445c380a7667d92f87d01d6703e42')"></h-option>
            <h-option value="1223" :label="h_i18n('5cb424765cb101866f47ca115605ce3b')"></h-option>
            <h-option value="1224" :label="h_i18n('cea0671a77281d4923d26111191e4fd8')"></h-option>
            <h-option value="1225" :label="h_i18n('abad330f7fe92f41627d9a704ee5fc9e')"></h-option>
            <h-option value="2160" :label="h_i18n('faed4c5f6d0759abc15ec2971cad306d')"></h-option>
            <h-option value="2161" :label="h_i18n('9d298bcaba9221bf30fd13a4b06e2683')"></h-option>
            <h-option value="2162" :label="h_i18n('cc939a5a94d19ffb864a8f14200237fe')"></h-option>
            <h-option value="2163" :label="h_i18n('f950331889d2172fbdeb4ddfbd135510')"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <h-autocomplete popper-class="planHidden" v-model="searchData.mtlNo" :fetch-suggestions="mtlNoChange"
            :trigger-on-focus="false" @input="() =>
                searchData.mtlNo.length < 4 ? (plan.showMtlPlan = false) : ''"
                @clear="plan.showMtlPlan = false" clearable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="detailBlur('showMtlPlan')"
                @focus="detailFocus('showMtlPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
              max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
            <div v-if="plan.showMtlPlan && plan.MtlOver600" style="color: red;height: 20px;background-color: #fff;
                padding-top: 3px;">
              <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('a1fc8066cb705fef975d7db6b39eaa79') }}</span>
            </div>
          </h-detail>
        </h-search>
        <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
          <h-input v-model="searchData.mtlName" clearable @change="changeNull(searchData.mtlName, 'mtlName')">
          </h-input>
        </h-search>
        <h-search :title="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')">
          <h-input v-model="searchData.sybName" clearable @change="changeNull(searchData.sybName, 'sybName')">
          </h-input>
        </h-search>
        <!-- <h-search title="下达者">
          <h-input v-model="searchData.inputMan" clearable @change="changeNull(searchData.inputMan, 'inputMan')">
          </h-input>
        </h-search> -->
        <h-search :title="h_i18n('37769e25fffd760203c860702167cd26')">
            <h-select v-model="searchData.appealStatus" clearable filterable @change="changeNull(searchData.appealStatus, 'appealStatus')">
              <h-option value="自动认可" :label="h_i18n('31b88d82c7738269292a70555719d18d')"></h-option>
              <h-option value="供方认可" :label="h_i18n('fcbda1a3b9a1f991de0b81f94ee7365c')"></h-option>
              <h-option value="待审核" :label="h_i18n('5cb424765cb101866f47ca115605ce3b')"></h-option>
              <h-option value="待终判" :label="h_i18n('9109d5ff67cfd588c1d5265d160a958f')"></h-option>
              <h-option value="终判通过" :label="h_i18n('db6e70ed7144c383e800dd36fe849cdf')"></h-option>
              <h-option value="终判不通过" :label="h_i18n('85d8dd6ea355bf679c4af04dc3c611c1')"></h-option>
            </h-select>
          </h-search>
        <h-search :title="h_i18n('e82da8a5ed89d557f32a2e784463fcd3')">
          <h-date-picker @change="TimeChange(searchData.inputDate, {start:'inputDateStart',end:'inputDateEnd'})" v-model="searchData.inputDate"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>
        <h-search :title="h_i18n('89933f7a7788af94c8672ef605220350')">
          <h-date-picker @change="TimeChange(searchData.requireRequestDate, {start:'requireRequestDateStart',end:'requireRequestDateEnd'})" v-model="searchData.requireRequestDate"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>
        <h-search :title="h_i18n('2e0c3e85c35dd1c5ff2c19eea0176502')">
          <h-select clearable v-model="searchData.isMouldReason" :placeholder="h_i18n('cb08af880c276d42e7773bcd88331d25')" filterable
            @change="changeNull(searchData.isMouldReason, 'isMouldReason')">
            <h-option value="1" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></h-option>
            <h-option value="0" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></h-option>
          </h-select>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('f37dba0758deb9ad0bead5f15776dd35')" :is-left="0" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <template v-for="item in data.btnListOfSqm" :key="item.code">
          <template v-if="item.code == 'mkhl_jbd_jbd_export'">
            <h-button @click="excleBtn()" :loading="data.exportLoading">
              <template #icon>
                <i class="iconfont icon-daochu"></i>
              </template>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
          </template>
        </template>
        <div class="tipBox_yellow">
          <img src="@/assets/img/tips-icon.png" class="tip-img" />
            {{ h_i18n('d17f22a7d4885ad074a6e11a63603990') }}
        </div>
      </template>

      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="data.tableLoading" height="540" @selection-change="listCheckBoxChange"
        border :data="data.dataOfTable" size="small" style="width: 100%; min-height: 540px">
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="rectifyId" :label="h_i18n('6c545c505fa3a4f3ffca3ddc4ae9b051')" width="150">
          <template #default="{row}">
            <span style="color:#165dff;cursor: pointer;" @click="goDetailBtn(row)">{{ row.rectifyId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rectifyStatusName" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="120">
          <template #default="{ row }">
            <el-tag v-if="row.rectifyStatusName == h_i18n('cea0671a77281d4923d26111191e4fd8')" type="success" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.rectifyStatusName == h_i18n('4a35e03b857bf3cde759bb1390f1bbac')" type="warning" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.rectifyStatusName == h_i18n('e17445c380a7667d92f87d01d6703e42')" type="warning" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.rectifyStatusName == h_i18n('5cb424765cb101866f47ca115605ce3b')" type="warning" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.rectifyStatusName == h_i18n('faed4c5f6d0759abc15ec2971cad306d')" type="warning" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.rectifyStatusName == h_i18n('abad330f7fe92f41627d9a704ee5fc9e')" type="danger" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.rectifyStatusName == h_i18n('f950331889d2172fbdeb4ddfbd135510')" type="danger" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.rectifyStatusName == h_i18n('9d298bcaba9221bf30fd13a4b06e2683')" type="danger" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.rectifyStatusName == h_i18n('cc939a5a94d19ffb864a8f14200237fe')" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else type="info" size="small">{{row.rectifyStatusName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130"></el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200" class-name="textalignleft_style"></el-table-column>
        <el-table-column prop="sybName" :label="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')" width="120"></el-table-column>
        <!-- <el-table-column prop="inputMan" label="下达者" width="80"></el-table-column> -->
        <el-table-column prop="inputDate" :label="h_i18n('e82da8a5ed89d557f32a2e784463fcd3')" min-width="120">
          <template #default="{row}">
            <span>{{ time(row.inputDate) }}</span>
          </template>
        </el-table-column> 
        <el-table-column prop="rectifyFromName" :label="h_i18n('383a6d166f8f60e16e726ccc9c483631')" width="80"></el-table-column> 
        <el-table-column prop="isMouldReasonName" :label="h_i18n('2e0c3e85c35dd1c5ff2c19eea0176502')" width="100"></el-table-column> 
        <el-table-column prop="requireRequestDate" :label="h_i18n('89933f7a7788af94c8672ef605220350')" min-width="120">
          <template #default="{row}">
            <span>{{ time(row.requireRequestDate) }}</span>
          </template>
        </el-table-column> 
        <el-table-column prop="rectifyDate" :label="h_i18n('f7cdc6ed0c0570d9b9beb5aad69d3682')" min-width="120">
          <template #default="{row}">
            <span>{{ time(row.rectifyDate) }}</span>
          </template>
        </el-table-column> 
        <el-table-column prop="" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" width="120" class-name="btn_cell_style">
          <template #default="{row}">
            <h-button v-if="(data.roleCode == 'S003'|| data.roleCode == 'S009') && (row.rectifyStatusId == '1222' || row.rectifyStatusId == '1225') && row.isValid == 'Y'"
            type="primary" @click="dealBtn(row)">{{ h_i18n('59c1d28ffbf075894cb2684f702476c5') }}</h-button>
          </template>
        </el-table-column> 
        <el-table-column prop="" :label="h_i18n('ee4c724a4dd16bde53ccda20ed8a8fb3')" width="100" class-name="btn_cell_style">
          <template #default="{row}">
            <h-button type="primary" @click="historyBtn(row)">{{ h_i18n('c827d8dbb76ce33219f64c6749893159') }}</h-button>
          </template>
        </el-table-column> 
        <el-table-column prop="appealStatus" :label="h_i18n('37769e25fffd760203c860702167cd26')" width="100">
          <template #default="{row}">
            <span v-if="row.appealStatus === '自动认可'">{{h_i18n('31b88d82c7738269292a70555719d18d')}}</span>
            <span v-if="row.appealStatus === '供方认可'">{{h_i18n('fcbda1a3b9a1f991de0b81f94ee7365c')}}</span>
            <span v-if="row.appealStatus === '待审核'">{{h_i18n('5cb424765cb101866f47ca115605ce3b')}}</span>
            <span v-if="row.appealStatus === '待终判'">{{h_i18n('9109d5ff67cfd588c1d5265d160a958f')}}</span>
            <span v-if="row.appealStatus === '终判通过'">{{h_i18n('db6e70ed7144c383e800dd36fe849cdf')}}</span>
            <span v-if="row.appealStatus === '终判不通过'">{{h_i18n('85d8dd6ea355bf679c4af04dc3c611c1')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" :label="h_i18n('91f741b843d731948ee812176615fd53')" class-name="btn_cell_style" width="200">
          <template #default="{row}">
            <template v-if="new Date(row.inputDate) < 1714492801000">
              <h-button type="primary" disabled>{{ h_i18n('191a39634a0499cfbe8b6f5fc822d74b') }}</h-button>
              &nbsp;
              <h-button type="danger" disabled>{{ h_i18n('ce6326e846e2c23e9a83fcfb9774685f') }}</h-button>
            </template>
            <template v-else>
              <h-button type="primary" @click="approval(row)" :disabled="row.appealStatus">{{ h_i18n('191a39634a0499cfbe8b6f5fc822d74b') }}</h-button>
              &nbsp;
              <h-button type="danger" @click="createAppeal(row)" :disabled="row.appealStatus">{{ h_i18n('ce6326e846e2c23e9a83fcfb9774685f') }}</h-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @current-change="getInfo"
        v-model:currentPage="searchData.current" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination>
    </h-table-card>
    <h-dialog :title="h_i18n('ee4c724a4dd16bde53ccda20ed8a8fb3')" :show="data.historyDialog" width="90%" class="dialog_style"
      @close="data.historyDialog = false , data.dialogData = []">
        <el-table :data="data.dialogData.slice((data.dialogPageNo - 1) * 10, data.dialogPageNo * 10)"
          v-loading="data.dialogLoading" border size="small" height="540">
          <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
          <el-table-column prop="reasonAnalyse" :label="h_i18n('9ab31c4ccc2fd91683751b8a3ad4680d')" width=""></el-table-column>
          <el-table-column prop="isMouldReason" :label="h_i18n('fdabb1ea7dcf4084d4d0ac32d0510ba2')" class-name="td-tableOfClass"
          :width="data.dialogData.some(item=>item.isMouldReason == '1') ? 400 : ''" >
            <template #default="{row , $index}">
              <div v-if="row.isMouldReason == '1'" class="wrapDiv">
                <el-table :data="data.dialogData[$index].mouldQuestionDTOList ? data.dialogData[$index].mouldQuestionDTOList.slice((data['inDialogPageNo'+$index] - 1) * 5, data['inDialogPageNo'+$index] * 5) : []"
                  class="tableOfClass">
                  <el-table-column :label="h_i18n('b3f39934f0d5c3dd565662f0689a920c')" prop="mouldCode" width="120"></el-table-column>
                  <el-table-column :label="h_i18n('e4ce58044256a96ac51b24d8ff981029')" prop="mouldImprove" width="80">
                    <template #default="{row}">
                      <div v-for="item in data.listBaseValues">
                        <span v-if="item.valueId == row.mouldImprove">{{ item.valueName }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="h_i18n('c6e8b038d5c4dec706a59054a5700c95')" prop="mouldDescription" width="100"> 
                  </el-table-column>
                  <el-table-column :label="h_i18n('b7dba1d9c3e7a85dbcb2bb66bb2eae1c')" prop="mouldPictureUrl">
                    <template #default="{row}">
                        <h-file :name="row.mouldPictureName" :delete-type="false" :url="row.mouldPictureUrl"></h-file>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination @current-change="inDialogCurrentChange($event,$index)" v-model:currentPage="data['inDialogPageNo'+$index]" small
                  :page-size="5" layout="total, prev, pager, next" :total="data['inDialogTotal'+$index]" :hide-on-single-page="true">
                </el-pagination>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="workAround" :label="h_i18n('32ed7f169270fae8080481c8eb1ffb1c')" width=""></el-table-column>
          <el-table-column prop="rigidFlexibility" :label="h_i18n('7a44d63bfcae580a2b2ec927ca7f3fa5')" width=""></el-table-column>
          <el-table-column prop="radicalMeasures" :label="h_i18n('60ed8203f18e1c11da65fc1f8f2eb4f2')" width=""></el-table-column>
          <el-table-column prop="rectifyDate" :label="h_i18n('e14ee8f04bf76d9b8b77fe478f3944f8')" width="120">
            <template #default="{row}">
              <span>{{ time(row.rectifyDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reformAuditStatusName" :label="h_i18n('8beefb1353a32743f7d67df0a113d264')" width="100"></el-table-column>
          <el-table-column prop="reformAuditMark" :label="h_i18n('bfd5d6b5e79c46c862980fa1bc3ae7c1')" width="80"></el-table-column>
          <el-table-column prop="reformAuditDate" :label="h_i18n('e6f0708789d7efc02f1a163224ae7fb0')" width="120">
            <template #default="{row}">
              <span>{{ time(row.reformAuditDate) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="dialogCurrentChange" v-model:currentPage="data.dialogPageNo"
          :page-size="10" layout="total, prev, pager, next,jumper" :total="data.dialogTotal" :hide-on-single-page="true">
        </el-pagination>
    </h-dialog>
  </h-list-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import hDialog from "../../../views/Templates/h-dialog.vue";
const { proxy, ctx } = getCurrentInstance()
const route = useRoute()

const searchData = reactive({
  mtlNo:'',
  current: 1,
  size: 10,
  queryFlag : 'sqm'
})
const data = reactive({
  total: 0,
  dataOfTable:[],
  keepalivestatus: 0,
  dialogPageNo:1,
  historyDialog:false,
  dialogData:[],
  dialogTotal:0,
  inDialogTotal:0,
  hisBtnRow:{},
  dealBtnRow:{},
  detailBtnRow:{},
  btnCodeList:[
    "mkhl_jbd_jbd_export",
  ],
  btnListOfSqm:[]
})

 /**
 * 传高度
 */
 const changeMethod = () => {
  proxy.postThisPageHeight();
};

/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
const listCheckBoxChange = (rowArr) => {
  console.log("rowArr", rowArr);
};

// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined;
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
};

// 两个模糊查询相关
const http = reactive({
  mtlSearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
  MtlOver600: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showMtlPlan") {
    if (searchData.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.mtlNo = row.mtlNo;
  plan.showMtlPlan = false;
};

/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.mtlNo.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    proxy
      .$http({
        method: "POST",
        url: "/base/basicData/searchMaterielList",
        headers: { "content-type": "application/json" },
        data: {
          mtlNo: searchData.mtlNo,
        },
        cancelToken: http.mtlSearchHttp.token,
      })
      .then((res) => {
        data.mtlNoList = res.data.data;
        if (data.mtlNoList.length >= 600) {
          plan.MtlOver600 = true;
          data.mtlLoading = false;
        } else {
          plan.MtlOver600 = false;
          data.mtlLoading = false;
        }
      })
      .catch((e) => { });
  }
};
// 两个模糊查询结束

// 时间范围选择
const TimeChange = (date, {start,end}) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
};
// 纠偏单详情
const goDetailBtn = (row) => {
  data.detailBtnRow = row
  proxy.$router.push({
    name: "RectifyReportDetail",
    query: {
      supplyCode:data.supplyCode,
      dataFrom:'sqm',
      rectifyId: data.detailBtnRow.rectifyId,
      sourceId:data.detailBtnRow.sourceId,
      rectifyFromName: data.detailBtnRow.rectifyFromName,
    }
  })
}
// 整改 
const dealBtn = (row) => {
  data.dealBtnRow = row
  proxy.$router.push({
    name: "RectifyReportReorganize",
    query: {
      supplyCode:data.supplyCode,
      dataFrom:'sqm',
      rectifyId: data.dealBtnRow.rectifyId,
      sourceId:data.dealBtnRow.sourceId,
      rectifyFromName: data.dealBtnRow.rectifyFromName,
      rectifyMan: data.trueName,
      rectifyManId: data.userName,
      source:data.dealBtnRow.source,
    }
  })
}
// 查看Dialog
const historyBtn = (row) => {
  data.historyDialog = true
  data.hisBtnRow = row
  data.dialogPageNo = 1
  getHistory()
}
// dialog table 翻页
const dialogCurrentChange = (v) => {
  data.dialogPageNo = v
}
// dialog内部 table 翻页
const inDialogCurrentChange = (v,index) => {
  data["inDialogPageNo"+index] = v
}
// 获取 整改历史
const getHistory = () => {
  data.dialogLoading = true
  proxy.$http({
    url: "/base/rejectsRectify/selectHistory",
    method: "post",
    params: {
      rectifyId: data.hisBtnRow.rectifyId,
    },
  }).then(res=>{
    data.dialogData = res.data.data
    let len = data.dialogData.length
    for(let i = 0;i < len; i++){
      console.log(data.dialogData[i].mouldQuestionDTOList)
      data['inDialogTotal'+i] = data.dialogData[i].mouldQuestionDTOList ? data.dialogData[i].mouldQuestionDTOList.length : 0
    }
    // data.dialogData.mouldList = data.dialogData.mouldList ? JSON.parse(data.dialogData.mouldList) : undefined
    data.dialogTotal = data.dialogData.length
    data.dialogLoading = false
    for(let i = 0 ; i < data.dialogData.length; i++){
      data['inDialogPageNo'+i] = 1
    }
    proxy.postThisPageHeight()
  }).catch(err=>{
    data.dialogData = []
    data.inDialogTotal = 0 
    data.dialogLoading = false
    proxy.postThisPageHeight()
  })
}
// 查询 
const getInfo = (flag) => {
  if (true == flag) {
    searchData.current = 1;
  }
  data.tableLoading = true;
  proxy.$http({
    url: "/base/rejectsRectify/pageInfo",
    method: "post",
    data: {
      ...searchData,
      mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
      inputDate: undefined,
      requireRequestDate: undefined,
      appealStatus: searchData.appealStatus ? searchData.appealStatus.split(",") : undefined,
      rectifyStatusId: searchData.rectifyStatusId ? searchData.rectifyStatusId.split(",") : undefined,
    },
  })
  .then((res) => {
    if (res.data.data) {
      data.dataOfTable = res.data.data.records;
      data.total = res.data.data.total;
      data.tableLoading = false;
    } else {
      data.dataOfTable = []
      data.tableLoading = false;
      proxy.info({ message: res.data.msg ? res.data.msg : h_i18n('21efd88b67a39834582ad99aabb9dc60'), title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
    }
  })
  .catch((err) => {
    data.dataOfTable = []
    data.tableLoading = false;
    proxy.warning({ message: err ? err : h_i18n('0d66ed02d74d0bd89431d6d59533ffb3') , title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
  });
};

// 导出 
const excleBtn = () => {
  if (data.total > 5000) {
    proxy.warning(
      { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
      {
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { },
      }
    );
    return;
  }
  data.exportLoading = true;
  proxy.startLoading(h_i18n('fa6da27aa435d4c6b6f4573e93407fb3'));
  proxy.httpFile(
    {
      method: "post",
      url: "/base/rejectsRectify/exportListSqm",
      data: {
        ...searchData,
        mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
        inputDate: undefined,
        requireRequestDate: undefined,
        size: undefined,
        current: undefined,
        appealStatus: searchData.appealStatus ? searchData.appealStatus.split(",") : undefined,
        rectifyStatusId: searchData.rectifyStatusId ? searchData.rectifyStatusId.split(",") : undefined,
      },
    },
    h_i18n('10582832fb1a43f8737fe74c26d605f0')
  ).then(res=>{
    data.exportLoading = false;
  }).catch(err=>{
    proxy.closeLoading()
    data.exportLoading = false;
  })
};

/**
 * 获取模具改进类
 * /basicData/listBaseValues
 */
 const getListBaseValues = () => {
  data.listBaseValuesLoading = true
  proxy.$http({
    method: "get",
    url: "/base/basicData/listBaseValues",
    params: {valueTypeId: 108 },
  }).then((res) => {
    if (res.data.code === "200") {
      data.listBaseValues = res.data.data
      data.listBaseValuesLoading = false
    } else {
      data.listBaseValuesLoading = false
      // console.log(res.data.msg)
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message:res.data.msg? res.data.msg : h_i18n('f50bf418323ee425eca7208c09a4577e')})
    }
  }).catch((err) => {
    data.listBaseValuesLoading = false
  });
}
// 认可 
const approval = (row) => {
  if(!row.rectifyId){
    proxy.info(h_i18n('4a4f22abeb51b7b42f8b200f326e93ed'))
    return
  }
  data.rectifyId = row.rectifyId
  // data.approvalLoading = true
  proxy.warning({title:h_i18n('900c70fa5f7dbc014e6f762d5e0e885c'),message:h_i18n('99652ba7c48d6bba558e3b2182e9c31a'),confirmButtonText:h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),
  callback: (action) => {
    if(action == 'confirm'){
      proxy.$http({
        method: "post",
        url: `/base/RefusalAppeal/updateRectify?rectifyId=${data.rectifyId}&appealStatus=${encodeURI('供方认可')}&usercode=${data.supplyCode}&username=${data.trueName}`,
      }).then(res=>{
        console.log(res)
        if (res.data.code == '0' && res.data.data == h_i18n('330363dfc524cff2488f2ebde0500896') && res.data.msg == '成功') {
          proxy.success(res.data.msg)
          getInfo()
        } else {
          proxy.info(res.data.msg)
        }
      }).catch(err=>{
        proxy.error(err)
      }).finally(()=>{
        data.rectifyId = ''
        // data.approvalLoading = false
      })
    }else{
      // data.approvalLoading = false
    }
  }
})
}

// 申诉
const createAppeal = (row) => {
  proxy.$router.push({
    name: 'addAppeal',
    query: {
      rectifyId:row.rectifyId,
      dataFrom:"sqm",
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      applyName: data.userName,
      userName: data.userName,
      kindType:'sqmAdd',
      comeFrom: '纠偏'
    }
  })
}

onBeforeMount(() => {
})
  
onMounted(() => {
  if(route.query.dataFrom != 'sqm'){
    proxy.$router.replace('/404')
    return
  }
  if(route.query.searchStatus == '1222'){
    searchData.rectifyStatusId = '1222'
  }
  if(!route.query.supplyCode){
    proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: (action) => { 
        proxy.$router.back()        
      },})
    return
  }
  if (route.query) {
    data.supplyCode = route.query.supplyCode;
    searchData.supplyCode = route.query.supplyCode;
    data.supplyName = route.query.supplyName;
    data.trueName = route.query.trueName;
    data.roleCode = route.query.roleCode;
    data.userName = route.query.userName;
  }
  if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }else{
    data.btnListOfSqm = [{code:'mkhl_jbd_jbd_export',name:'导出'}]
  }
  getInfo();
  getListBaseValues()
})

onActivated(() => {
  if (data.keepalivestatus == 0) {
    // console.log("首次打开");
    data.keepalivestatus ++ 
  } else {
    proxy.postThisPageHeight();
    // console.log("操作完之后打开");
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    getInfo()
  }
})
onDeactivated(() => {
  // console.log("keepalive-deactivated页面关闭时触发");
})
</script>

<style lang="scss">
.RectifyReportList_style {
  .el-table td.textalignleft_style .cell {
    text-align: left !important;
  }
  .btn_cell_style{
    padding: 0px !important;
  }
  .haier-card .haier-card--body .el-table tr td {
    padding: 11.1px 0;
  }
}
.planHidden {
  display: none;
}
.dialog_style .haier-dialog {
  top: 100px;
}
.td-tableOfClass{
  padding: 0px !important;
  :deep(.cell){
    padding: 0px !important;
  }
}
.tableOfClass{
  width: 100%;
  border-right:1px solid rgb(236, 236, 236);
  border-left:1px solid rgb(236, 236, 236);
  .el-table__header-wrapper{
    table{
      thead{
        tr{
          th{
            font-size: 12px !important;
            font-weight: 500 !important;
            height: 28px !important;
            padding: 0px !important;
            background-color: #E8F3FF;
            border-right:0px !important;
          }
        }
      }
    }
  }
  .el-table__body-wrapper{
    .el-table__empty-block{
      min-height: 28px !important;
      .el-table__empty-text{
        line-height: 28px;
        font-size: 12px;
      }
    }
    .el-table__body{
      .el-table__row{
        td{
          font-size: 12px;
          line-height: 28px;
          padding: 0px !important;
          height: 28px;
          border-right: 0px !important;
          .cell{
          }
        }
      }
    }
  }
}
.wrapDiv{
  .el-pagination{
    height: 24px;
    span{
      font-size: 12px;
    }
    button{
      background: transparent !important;
    }
    ul{
      background: transparent !important;
      li{
        background: transparent !important;
      }
    }
  }
}
</style>